module.exports = __webpack_public_path__ + "static/media/przemiana1_right.d4d80a37.jpeg";